module.exports = __webpack_public_path__ + "img/team-chat-zero-state.2506b4eb.svg";